// from Webamp demo

export const initialTracks = [
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/%E5%91%A8%E6%B7%B1%20-%20Rubia.flac',
    duration: 194.558,
    metaData: {
      title: 'Rubia',
      artist: '周深',
      album: 'Rubia',
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/%E5%91%A8%E6%B7%B1%20-%20%E6%9C%9B.flac',
    duration: 250.547,
    metaData: {
      title: '望',
      artist: '周深',
      album: '望',
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/%E7%8E%8B%E8%8F%B2%20-%20%E5%A6%82%E6%84%BF.flac',
    duration: 265.383,
    metaData: {
      title: '如愿',
      artist: '王菲',
      album: '如愿',
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/%E8%83%A1%E6%AD%8C%20-%20%E5%BF%98%E8%AE%B0%E6%97%B6%E9%97%B4.flac',
    duration: 272.106,
    metaData: {
      title: '忘记时间',
      artist: '胡歌',
      album: '仙剑奇侠传三 电视剧原声带',
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/%E4%BA%94%E6%9C%88%E5%A4%A9%2C%E5%AD%99%E7%87%95%E5%A7%BF%20-%20%E6%B8%A9%E6%9F%94%20%23MaydayBlue20th.flac',
    duration: 271.018,
    metaData: {
      title: '温柔 #MaydayBlue20th',
      artist: '五月天, 孙燕姿',
      album: '温柔 #MaydayBlue20th',
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/F.I.R.%E9%A3%9E%E5%84%BF%E4%B9%90%E5%9B%A2%20-%20%E6%88%91%E4%BB%AC%E7%9A%84%E7%88%B1.flac',
    duration: 287.027,
    metaData: {
      title: '我们的爱',
      artist: '飞儿乐团',
      album: '飞儿乐团',
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/G.E.M.%E9%82%93%E7%B4%AB%E6%A3%8B%20-%20%E5%8F%A5%E5%8F%B7.flac',
    duration: 235.632,
    metaData: {
      title: '句号',
      artist: '邓紫棋',
      album: '摩天动物园',
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/%E5%91%A8%E6%9D%B0%E4%BC%A6%20-%20%E5%A4%9C%E6%9B%B2.flac',
    duration: 226.827,
    metaData: {
      title: '夜曲',
      artist: '周杰伦',
      album: '十一月的萧邦',
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/%E9%99%88%E6%85%A7%E5%A8%B4%20-%20%E5%8D%83%E5%8D%83%E9%98%99%E6%AD%8C.flac',
    duration: 299.4,
    metaData: {
      title: '千千阙歌',
      artist: '陈慧娴',
      album: '永远是你的朋友',
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/U.S.A.%20For%20Africa%20-%20We%20Are%20The%20World.flac',
    duration: 427.333,
    metaData: {
      title: 'We Are The World',
      artist: 'U.S.A. For Africa',
      album: 'We Are The World',
    },
  },
  {
    url:
      'https://raw.githubusercontent.com/luxiangzh/winXP/32c9b34/src/assets/winamp/Odesza%20-%20A%20Moment%20Apart.flac',
    duration: 234.244,
    metaData: {
      title: 'A Moment Apart',
      artist: 'Odesza',
      album: 'A Moment Apart (Deluxe Edition) [Explicit]',
    },
  },
];
